<div class="grid-container">
  @if (this.requestState.isLoading()) {
    <div class="grid-loading-bar"></div>
  }

  <ag-grid-angular
    class="ag-theme-skin grid-element"
    [components]="this.components"
    [rowHeight]="this.rowHeight"
    [domLayout]="this.domLayout()"
    [style.height.px]="this.gridHeight()"
    [rowModelType]="this.rowModelType"
    [getRowId]="this.getRowId"
    [loadingCellRenderer]="this.loadingCellRenderer"
    [suppressNoRowsOverlay]="true"
    (gridReady)="this.isReady($event)"
    (gridSizeChanged)="this.onGridLayoutChanged($event.clientWidth)"
    (displayedColumnsChanged)="this.onGridLayoutChanged()"
    (modelUpdated)="this.onModelUpdated($event)"
    [suppressPaginationPanel]="true"
  >
  </ag-grid-angular>

  @if (this.allowStructureEdition() && this.allowedRowTypes().length > 0) {
    @if (this.isEmpty()) {
      <div class="empty-cta-overlay">
        <cam-editabled-cta-row
          [large]="true"
          [allowedTypes]="this.allowedRowTypes()"
          (addLine)="this.addLine($event)"
        ></cam-editabled-cta-row>
      </div>
    } @else {
      <cam-editabled-cta-row
        [allowedTypes]="this.allowedRowTypes()"
        (addLine)="this.addLine($event)"
      ></cam-editabled-cta-row>
    }
  }
</div>
